<template>
  <span>
    <Icon
      class="add-dash-icon"
      type="md-add"
      @click.stop="showAddModal"
      title="添加概览"
    />
    <Modal v-model="addModal" title="添加概览">
     <div class='flex' style='align-items: center;'>
      <span>概览名称：</span>
      <Input
        style='flex: 1;'
        type="text"
        placeholder="输入概览名称"
        v-model="dashName"
      />
     </div>
      <div slot="footer">
        <Button @click="addModal = false">取消</Button>
        <Button type="primary" @click="addDashboard">确定</Button>
      </div>
    </Modal>
  </span>
</template>

<script>
import api from "@/libs/api";
import util from "@/libs/util";
import { mapState } from "vuex";

export default {
  name: "add-dashboard",
  data() {
    return {
      addModal: false,
      dashName: "",
    };
  },
  computed: {
    ...mapState({
      dashList: (state) => state.dashboards.dashList,
      projectId: (state) => state.app.projectId,
    }),
  },
  methods: {
    showAddModal() {
      this.addModal = true;
      this.dashName = "";
    },
    addDashboard() {
      const param = {
        dashName: this.dashName,
        rank: 1,
        config: {
          accuracy: "district",
          refresh: "immediate",
          sampling: 64,
        },
      };
      let selfDashList = this.dashList.filter((item) => item.self === true);
      if (selfDashList.some((item) => item.name === this.dashName)) {
        this.$Message.warning("概览名称不能重复");
      } else if (this.dashName === "") {
        this.$Message.warning("概览名称不能为空");
      } else {
        api.addDashboard(this.projectId, param).then((res) => {
          if (res.data.status === 1) {
            this.$Message.success("添加成功");
            this.addModal = false;
            util.setDashboardsMenu();
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.add-dash-icon:hover {
  color: #0084FF;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboards/add-dashboard.vue